<template>
    <div class="contact-body-top">  
        <p>WMADCC was establilshed to help senior citizens in the community by providing quality and loving care. Let us take care of you or your loved one.</p>
    </div>
   
    <div class="contact-body-center">  
      <div class="center-line-1">
        <p>Opened Monday - Saturday, 7:00 a.m. - 1:00 p.m.</p>
      </div>

      <div class="center-line-2">
        <p>Safe & loving environment</p>
      </div>

      <div class="center-line-3">
        <p>Personal care</p>
      </div>

      <div class="center-line-4">
        <p>Nursing services</p>
      </div>

      <div class="center-line-5">
        <p>Medication monitoring</p>
      </div>

      <div class="center-line-6">
        <p>Social services</p>
      </div>

      <div class="center-line-7">
        <p>Therapeutic activities</p>
      </div>

      <div class="center-line-8">
        <p>Lunch/snacks</p>
      </div>

      <div class="center-line-9">
        <p>Transportation</p>
      </div>

      <div class="center-line-10">
        <p>Respite care</p>
      </div>

      <div class="center-line-11">
        <p>Field trips</p>
      </div>
    </div>

    <div class="contact-body-low">
        <div class="low-line-1">
            <p>The medical day care program is funded by:</p>
        </div>
        <div class="low-line-2">
            <p>Medicaid, County Subsidy, Long Term Insurance and/or Private.</p>
        </div>
    </div>

    <div class="contact-body-person">
        <div class="person-line-1">
            <p>Don't Delay, Call Today,</p>
        </div>
        <div class="person-line-2">
            <p>Sharon</p>
        </div>
        <div class="person-line-3">
            <p>(667) 200-6325</p>
        </div>
        <div class="person-line-4">
            <p>E-mail: info@wmadcc.org</p>
        </div>
    </div>   

</template>
    
<script>
  export default {
    name: 'ContactBody'
  }  
</script>

    
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .contact-body-top {
    text-align: left;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1.7rem;
    justify-content: top left;
    margin-top: 2vw;
    margin-bottom: 2vw;
    margin-left: 4vw;
    margin-right: 2vw;
  }

  .contact-body-center {
    text-align: center;
    font-size: 1.5rem;
    line-height: 1vh;  
  }

  .center-line-1 {
    text-align: center;
    color: rgb(0, 128, 11);

  }

  .center-line-2 {
    text-align: center;
    color: rgb(255, 51, 0);
  }

  .center-line-3 {
    text-align: center;
    color: rgba(0, 89, 255, 0.733);
  }

  .center-line-4 {
    text-align: center;
    color: orangered;
  }

  .center-line-5 {
    text-align: center;
    color: rgba(165, 42, 42, 0.815);
  }

  .center-line-6 {
    text-align: center;
    color: rgb(0, 128, 11);
  }

  .center-line-7 {
    text-align: center;
    color: purple;
  }

  .center-line-8 {
    text-align: center;
    color: orange;
  }

  .center-line-9 {
    text-align: center;
    color: rgba(165, 42, 42, 0.815);
  }

  .center-line-10 {
    text-align: center;
    color: rgba(0, 89, 255, 0.733);
  }

  .center-line-11 {
    text-align: center;
    color: orangered;
  }

  .contact-body-low{
    text-align: left;
    font-size: 1.3rem;
    line-height: 1rem;
    margin-top: 4vw;
    margin-left: 4vw;
  }

  .low-line-1 {
    text-align: left;
    font-weight: bold;
  }

  .low-line-2 {
    text-align: left;
    font-weight: bold;
    color: blue;

  }

  .contact-body-person {
    justify-content: center;
    font-size: 1.7rem;
    font-weight: bold;
    line-height: 1.4rem;
    margin-top: 3rem;
  }

  .person-line-1, .person-line-2, .person-line-3, .person-line-4 {
    text-align: center;
  }
}

/* for Phone */
@media (max-width:700px) {

  .contact-body-top {
    text-align: left;
    font-size: 1.1rem;
    font-weight: bold;
    line-height: 1.2rem;
    justify-content: top left;
    margin-top: 2rem;
  }

  .center-line-1, .center-line-2, .center-line-3, .center-line-4, .center-line-5, .center-line-6, .center-line-7, .center-line-8, .center-line-9, .center-line-10, .center-line-11 {
    text-align: center;
    color: darkblue;
    font-size: 1.3rem;
    line-height: 1rem;
  }

  .low-line-1 {
    text-align: left;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 1rem;
    margin-top: 2rem;
  }

  .low-line-2 {
    text-align: left;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 1rem;
    margin-top: -0.5rem;
    margin-bottom: 2rem;
  }

  .person-line-1, .person-line-2, .person-line-3, .person-line-4 {
    text-align: center;
    color: blue; 
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 1rem;
    margin-top: 0.5rem; 
  }

}


</style>